import User from '../interfaces/User';
import { useCompanyQuery } from './queries/useCompany';

// Backed by the shared ['company', id] query so that invalidations (e.g.
// after saving company details in Settings) propagate to every consumer
// without a page refresh.
const useCompany = (user: User | null) => {
  const companyId = user?.company_id as string | undefined;
  const { data } = useCompanyQuery(companyId, !!companyId);

  return { companyDetails: data?.message ?? undefined };
};

export default useCompany;
